<!--
 * @Author: cryi.liu
 * @Date: 2020-06-14 11:51:50
 * @LastEditTime: 2020-06-16 12:25:50
 * @Description: 审批人试卷审批操作栏
-->
<template>
  <div class="approval-action-bar">
    <pss-button text="同意" class="agree" @on-click="submitAgreeHandler" />
    <pss-button text="拒绝" @on-click="submitRefuseHandler" />
    <reject-comment-modal
      :approveId="approveId"
      :modal-show="rejectCommentModalShowState"
      :spring-mvc-token="springMvcToken"
      @close-modal="closeRejectCommentModalHandler" />
  </div>
</template>

<script>
import axios from 'axios';
import RejectCommentModal from './RejectCommentModal.vue';

export default {
  name: 'ApprovalActionBar',
  components: {
    RejectCommentModal,
  },
  props: {
    approveId: { type: [Number, String], required: true },
    springMvcToken: { type: String, required: true },
  },
  data() {
    return {
      rejectCommentModalShowState: false,
      comment: '',
    };
  },
  methods: {
    /**
     * 同意
     */
    submitAgreeHandler() {
      if (window.confirm('确认同意此次审批?')) {
        this.requestAgreeApprovalHandler();
      }
    },
    requestAgreeApprovalHandler() {
      this.requestAgreeApproval()
        .then(() => {
          alert('提交成功！');
          window.location.href = document.referrer;
        })
        .catch(() => {
          alert('提交失败，请联系管理员！');
        });
    },
    requestAgreeApproval() {
      return new Promise(async (resolve, reject) => {
        const result = await axios.post(`/mvc/exam/approval/approve/${this.approveId}?springMvcToken=${this.springMvcToken}&comments=${this.comment}`);
        if (result.data) {
          resolve(result.data);
        } else {
          reject(result.data);
        }
      });
    },
    /**
     * 拒绝
     */
    async submitRefuseHandler() {
      this.rejectCommentModalShowState = true;
    },
    /**
     * 关闭拒绝审批理由填写模态框
     */
    closeRejectCommentModalHandler() {
      this.rejectCommentModalShowState = false;
    },
  },
};
</script>

<style lang="less" scoped>
.approval-action-bar {
  display: flex;
  justify-content: center;
  width: 100%;

  .agree {
    margin-right: 20px;
  }
}
</style>
